<template>
  <v-app id="app" style="height:100vh;overflow-x:hidden;" :key="this.$i18n.locale">
    <meta charset="UTF-8">
    <meta name="google" content="notranslate">
    <meta http-equiv="Content-Language" content="fr">
    <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">
    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet">
    <SideMenu/>
    <PageHeader v-if="$store.state.user" />
    <v-content>
    <v-container :class="className" fluid>
      <router-view />
    </v-container>
  </v-content>
  </v-app>
</template>

<script>
import PageHeader from './components/Header'
import SideMenu from './components/SideMenu'
export default {
  name: 'App',
  data () {
    return {
      className: ''
    }
  },
  components: {
    PageHeader,
    SideMenu
  },
  mounted: function () {
    if (!this.$store.state.user) {
      this.$router
        .push({
          name: 'Login'
        })
        .catch(() => {})
    } else {
      this.className = 'container-custom'
      this.$vuetify.theme.dark = sessionStorage.theme === 'dark'
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'Login') {
        this.className = ''
      } else {
        this.className = 'container-custom'
      }
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
